import Clipboard from "clipboard/dist/clipboard.min"

export const clipboardInit = () => {
  new Clipboard(".clipboard")
}
